import { ChangeDetectionStrategy, Component, input, ViewEncapsulation, inject, output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ApTextareaComponent } from '@ap/textarea';

import content from './chat-textarea.content.json';

@Component({
    selector: 'ap-chat-textarea',
    templateUrl: 'chat-textarea.component.html',
    styleUrls: ['./chat-textarea.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule, ApContentPipe, ApTextareaComponent]
})
export class ApChatTextareaComponent {
    protected readonly contentService = inject(ApContentService);

    /**
     * Required - Label to show in modal dropdown input field
     */
    public readonly label = input<string>(`chat-textarea.label`);

    /**
     * Optional control input. Passed on to selector
     */
    public readonly control = input<FormControl<string>>(new FormControl());

    /**
     * Maximum allowed characters. Shows the countdown element in the top/right when typing.
     * Defaults to 150
     */
    public readonly maxCharacters = input<number>(150);

    /**
     * Emits event if textarea is blurred.
     */
    public readonly textareaBlur = output<void>();

    /**
     * Emits event if icon is clicked
     */
    public readonly iconClick = output<string>();

    constructor() {
        this.contentService.addContentItems(content);
    }
}
